import moment from 'moment'
import { IFileProps } from './File'
import { MessageProperties, MessageUser, RelationHospital } from '@/infrastructure/network/Monitaro/schema/models'
import UserEntity, { IUserProps } from '@/entities/User'

export interface IMessageProps {
  id?: string
  hospitalId: string | null
  hospital?: RelationHospital | null
  type: string | null
  from: string | null
  title: string | null
  content: string | null
  temporary?: string | null
  users: IUserProps[] | null
  recipients?: MessageUser[] | null
  industries: string[] | null
  properties: MessageProperties | null
  files?: IFileProps[]
  sentAt: string | null
  createdAt: string | null
  updatedAt: string | null
  data?: File[] | null
  keeps?: IFileProps[] | null
}

export interface IMessageQueryProps {}

export default class MessageEntity {
  private _props: IMessageProps

  constructor(props?: IMessageProps | null) {
    this._props = EmptyMessagePropsFactory(props)
  }

  get props(): IMessageProps {
    return this._props
  }

  get clone(): IMessageProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get hospitalId(): string | null {
    return this._props.hospitalId
  }

  get hospital(): RelationHospital | null | undefined {
    return this._props.hospital
  }

  get from(): string | null {
    return this._props.from
  }

  get title(): string | null {
    return this._props.title
  }

  get content(): string | null {
    return this._props.content
  }

  get users(): UserEntity[] | null[] | undefined {
    return this._props.users ? this._props.users.map((prop) => new UserEntity(prop)) : []
  }

  get industries(): string[] | null {
    return this._props.industries
  }

  get properties(): MessageProperties | null | undefined {
    return this._props.properties
  }

  get delivery(): string {
    return deliveryTexts.find((prop) => this.type === prop.value)?.text || '-'
  }

  get files(): IFileProps[] | null | undefined {
    return this._props.files
  }

  get type(): string | null {
    return this._props.type
  }

  get sentAt(): string | null {
    if (this._props.sentAt) {
      return moment(this._props.sentAt).format('YYYY/MM/DD HH:mm')
    } else if (this._props.properties?.temporary) {
      return '配信テスト済'
    }
    return '【一時保存】'
  }

  get createdAt(): string | null {
    return this._props.createdAt ? moment(this._props.createdAt).format('YYYY/MM/DD HH:mm') : null
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [
  { text: '作成日時', value: 'createdAt' },
  { text: 'タイトル', value: 'title', class: 'space-normal' },
  { text: 'メール送信者名', value: 'from', class: 'space-normal' },
  { text: '送信種別', value: 'delivery' },
  { text: '送信日時', value: 'sentAt' }
]

export const deliveries = [
  { text: 'すべての担当者に通知する', value: 'broadcast' },
  { text: '業種で選択して通知する', value: 'industries' },
  { text: '担当者を選択して通知する', value: 'direct' }
]

export const deliveryTexts = [
  { text: 'すべて', value: 'broadcast' },
  { text: '業種指定', value: 'industries' },
  { text: '担当者指定', value: 'direct' }
]

export const EmptyMessageQueryPropsFactory = (props?: Partial<IMessageQueryProps> | null): IMessageQueryProps => ({
  ...props
})

export const EmptyMessagePropsFactory = (props?: Partial<IMessageProps> | null): IMessageProps => ({
  hospitalId: null,
  type: 'broadcast',
  from: null,
  title: null,
  content: null,
  users: null,
  industries: null,
  properties: null,
  sentAt: null,
  createdAt: null,
  updatedAt: null,
  temporary: null,
  data: null,
  ...props
})
